import $ from 'jquery';

class menu {
  constructor() {
    this.openButton = $('.site-header__menu-trigger');
    this.closeButton = $('.site-header__menu-trigger.open');
    this.menuOverlay = $('.overlay-menu');
    this.isOverlayOpen = false;
    this.events();
    this.body = $('body');
  }

  events() {
    this.openButton.on('click', this.openMenuOverlay.bind(this));
    this.checkLinksForOutbound();
  }

  openMenuOverlay() {
    if (!this.isOverlayOpen) {
      this.checkLinksForOutbound();
      this.menuOverlay.addClass('overlay-menu--active');
      this.body.addClass('body-no-scroll');
      this.openButton.addClass('open');
      this.isOverlayOpen = true;
    } else {
      this.menuOverlay.removeClass('overlay-menu--active');
      this.body.removeClass('body-no-scroll');
      this.openButton.removeClass('open');
      this.isOverlayOpen = false;
    }
  }

  checkLinksForOutbound() {
    let links = document.querySelectorAll(
      '.navigation__menu > .menu-item > a, .footerNav__menu > .menu-item > a'
    );
    for (let i = 0; i < links.length; i++) {
      let link = links[i];
      if (link.host !== window.location.host && !link.host.includes('marsdd.com')) {
        // console.log("link.host: ", link.host);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
        link.setAttribute('aria-label', 'Opens in a new window');
      }
    }
  }
}

export default menu;
